module.exports = __webpack_public_path__ + "img/education-explore.aef058e6.jpg";